'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.loadBarriers = loadBarriers;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */

var LOAD = 'LOAD';
var LOAD_FAIL = 'LOAD_FAIL';
var LOAD_BARRIERS = 'LOAD_BARRIERS';

var initialState = {
  loaded: false,
  updating: false,
  updateError: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loaded: false,
        updating: true
      });
    case LOAD_BARRIERS:
      return (0, _extends3.default)({}, state, {
        loaded: true,
        'barriers': action.result
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loaded: false
      });
    default:
      return state;
  }
}

function isLoaded(globalState) {
  return globalState.admin && globalState.admin.loaded;
}

function loadBarriers() {
  return {
    types: [LOAD, LOAD_BARRIERS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/admin/getBarriers');
    }
  };
}
/* eslint-enable */


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/adminBarriers.js
// module id = 515
// module chunks = 0